import React from "react";
import { cn } from "@/lib/utils";

interface DetailFieldProps {
  label: string;
  value: string | React.ReactNode;
  className?: string;
}

/**
 * DetailField - Reusable label-value display component
 *
 * Label: font-weight 700, font-size 14px, line-height 20px, neutral-900
 * Value: font-weight 400, font-size 14px, line-height 20px, neutral-900
 */
export function DetailField({ label, value, className }: DetailFieldProps) {
  return (
    <div className={cn("aero:flex aero:flex-col aero:gap-1", className)}>
      <span
        className={cn(
          "aero:font-inter aero:font-bold aero:text-sm aero:leading-5",
          "aero:tracking-[0px] aero:align-middle aero:text-foreground"
        )}
      >
        {label}
      </span>
      <span
        className={cn(
          "aero:font-inter aero:font-normal aero:text-sm aero:leading-5",
          "aero:tracking-[0px] aero:align-middle aero:text-foreground"
        )}
      >
        {value}
      </span>
    </div>
  );
}

interface DetailFieldGridProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * DetailFieldGrid - Grid container for DetailField components
 * Uses grid-cols-2 on md breakpoint
 */
export function DetailFieldGrid({ children, className }: DetailFieldGridProps) {
  return (
    <div
      className={cn(
        "aero:grid aero:grid-cols-1 aero:md:grid-cols-2 aero:gap-4",
        className
      )}
    >
      {children}
    </div>
  );
}
